import { Link } from 'react-router-dom'
import { PAGE_STANDARD } from '../lib/layout.js'
import { BTN_PRIMARY } from '../lib/ui.js'

// #338: with `/:year` in the routing table, any single unknown segment reaches
// the calendar. Without this, `/banana` rendered a calendar with no events —
// indistinguishable from "the Office of the CTO has nothing scheduled", which
// is a far worse thing to say by accident than "no such page".
export default function NotFound() {
  return (
    <main className={`${PAGE_STANDARD} pb-12 pt-8 sm:pt-10`}>
      <div className="rounded-2xl bg-white p-10 text-center shadow-sm ring-1 ring-slate-200/60">
        <h1 className="text-base font-semibold text-slate-900">Page not found</h1>
        <p className="mt-1 text-sm text-slate-500">
          That address doesn&rsquo;t match anything here.
        </p>
        <Link
          to="/"
          className={`${BTN_PRIMARY} mt-4`}
        >
          Back to the calendar
        </Link>
      </div>
    </main>
  )
}
